<script>
  import MediaQuery from "../../components/MediaQuery.svelte";
  import NavbarDesktop from "../../components/NavbarDesktop.svelte";
  import NavbarMobile from "../../components/NavbarMobile.svelte";

  let innerWidth;
</script>

<svelte:window bind:innerWidth />

<header>
  <div class="logo-img">
    <img src="./assets/images/logo.png" alt="Learning Lab" />
  </div>

  <MediaQuery query="(min-width: 851px)" let:matches>
    {#if matches}
      <div class="spacer" />
      <NavbarDesktop />
    {:else}
      <NavbarMobile />
    {/if}
  </MediaQuery>
</header>

<style>
  .logo-img {
    flex-shrink: 0;
    margin-left: 72px;
    width: 213px;
    height: 53px;
  }

  .spacer {
    width: 400px;
  }

  header {
    position: fixed;
    top: 0;
    z-index: 999999;
    display: flex;
    align-items: center;

    max-width: 1440px;
    height: 80px;

    margin-right: -30px;

    background: #f9f9f9;
    box-shadow: 0px 10px 36px rgba(86, 102, 237, 0.25);
  }

  @media (max-width: 1300px) {
    .logo-img {
      margin-left: 16px;

      width: 141px;
      height: 35px;
    }

    header {
      position: fixed;
      top: 0;
      width: 100%;
      margin-right: 0;
      height: 56px;
      justify-content: space-between;
    }
  }

  @media (max-width: 850px) {
    .logo-img {
      margin-left: 16px;

      width: 141px;
      height: 35px;
    }

    header {
      position: fixed;
      margin-right: 0;
      width: 100%;
      height: 56px;
      justify-content: space-between;
    }
  }
</style>
